import FileInput from "@/components/form-controls/FileInput";
import { fileToBase64 } from "@/utils/conversion";
import { useFormContext } from "react-hook-form";

const documentConfig = [
    { label: "Tax Clearance from ZRA and TRA", placeholder: "Maximum file size: 12 MB", key: "taxClearancefromZRAandTRA" },
    { label: "Certificate of Incorporation", placeholder: "Maximum file size: 12 MB", key: "cirtificateofIncorporation" },
]

export default function DocumentsDetailsForm() {
    const { setValue } = useFormContext();

    const onFileChange = async (value: FileList, key: string) => {
        const base64String = await fileToBase64(value[0]) as string;
        setValue(key, base64String); 
    };

    return (
        <div>
            <h1 className="text-lg font-bold">Document Upload</h1>
            <p className="text-xs">Upload the required documents for the application.</p>
            <div className="grid grid-cols-1 gap-2 mt-2">
                {documentConfig?.map((doc) => (
                    <FileInput
                        key={doc.key}
                        label={doc.label}
                        placeholder={doc.placeholder}
                        className="col-span-2"
                        
                        onChange={(value) => onFileChange(value, doc.key)}
                        formats={"Supported formats: PDF"} 
                    />
                ))}
            </div>
        </div>
    );
}
